// extracted by mini-css-extract-plugin
module.exports = {"preview":"preview_preview__F_Zwi","message":"preview_message__twyT7"};